import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/userStore';
import SearchView from '../views/SearchView.vue'
import AppLayout from '../components/AppLayout.vue'
import LoginPage from '../components/LoginPage.vue'
import OnlineTTS from '../components/OnlineTTS.vue'
import RssCardGrid from '../components/RssCardGrid.vue'
import AdminDashboard from '../components/AdminDashboard.vue'
import LogManagement from '../components/LogManagement.vue'
import UserManagement from '../components/UserManagement.vue'
import StatisticsDashboard from '../components/StatisticsDashboard.vue'
import PipelineMonitor from '../components/PipelineMonitor.vue'

const routes = [
  {
    path: '/',
    component: AppLayout,
  },
  {
    path: '/card-view',
    component: RssCardGrid,
  },
  {
    path: '/login',
    component: LoginPage,
  },
  {
    path: '/admin',
    component: AdminDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/tts',
    component: OnlineTTS,
    meta: { requiresAuth: true },
  },
  {
    path: '/search',
    name: 'search',
    component: SearchView
  },
  {
    path: '/logs',
    component: LogManagement,
    meta: { requiresAuth: true },
  },
  {
    path: '/user-management',
    component: UserManagement,
    meta: { requiresAuth: true },
  },
  {
    path: '/statistics',
    component: StatisticsDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/pipeline',
    component: PipelineMonitor,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes,
});

// 添加全局错误处理
router.onError((error) => {
  console.error('Router error:', error);
  // 在错误发生时重定向到首页
  router.push('/');
});

// 导航守卫以检查登录状态
router.beforeEach((to, from, next) => {
  try {
    const authStore = useAuthStore();
    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
      next({ path: '/login', query: { redirect: to.fullPath } });
    } else {
      next();
    }
  } catch (error) {
    console.error("Error in navigation guard:", error);
    next('/');
  }
});

export default router;
